import { MailBasketAction } from '@agent/core/basket';
import { BasketStore } from '@agent/core/basket/basket.store';
import { Injectable, Injector } from '@angular/core';
import { NG1_BASKET_STORE } from '@commons/core/core.provider.ajs';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { tap } from 'rxjs';

import { BasketAction } from '@contact/upgrade';

@Injectable()
export class AgentMailEffect {
  /**
   * Initialize success effect
   */
  initSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(BasketAction.UpdateCounters),
        // refresh basket
        tap(() => (this.injector.get(NG1_BASKET_STORE) as BasketStore).dispatch(new MailBasketAction.AutoRefresh()))
      ),
    { dispatch: false }
  );

  constructor(private readonly actions$: Actions, private readonly injector: Injector) {}
}
